//import { HttpHeaders } from '@angular/common/http';
import { BadInputError } from './../common/bad-input-error';
import { error } from 'selenium-webdriver';
import { AppError } from './../common/app-error';
import { Observable } from 'rxjs/Observable';
import { Http, ResponseOptionsArgs, RequestOptionsArgs, Headers, RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { stringify } from '@angular/compiler/src/util';
import { Response } from '@angular/http/src/static_response';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import { NotFoundError } from '../common/not-found-error';

const formData:FormData = new FormData();

@Injectable()
export class DataService {

  constructor(private http:Http) {
    
   }  

   post(url,postData){
    formData.append('data', JSON.stringify(postData));
    let headers = new Headers();
    //set headers
    headers.append('Accept', 'application/json');

     return this.http.post(url,formData, { headers: headers })
     .map(repsonds=>{
       return repsonds.json();
       
     })
     .catch(this.handleError);
   }

   private handleError(error: ResponseOptionsArgs) {

    if (error.status === 404)
      return Observable.throw(new NotFoundError(error));

    if (error.status === 400)
      return Observable.throw(new BadInputError(error));

    return Observable.throw(new AppError(error));
  }
  


}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/services/data.service.ts